// Client-side helper for the Large Projects (Custom Projects) module.
//
// The LP backend lives on besthand-api, NOT in besthand-web. A thin server-side
// proxy (`POST /lp-graphql`, see src/core/lpApi/lpProxyRoute.js) forwards a
// GraphQL operation to besthand-api's /graphql using the logged-in user's auth
// cookie. From the browser we just POST `{ query, variables }` to that proxy.
//
// SECURITY: we send `credentials: 'same-origin'` so the `id_token` cookie rides
// along to our own origin; the proxy (not the browser) re-attaches it as the
// `authToken` header besthand-api expects. No token is ever read in JS here.
//
// Returns the parsed GraphQL response: `{ data?, errors? }`. Callers should
// check both `errors` (proxy/api/network failures, GraphQL-shaped) and the
// per-operation `status`/`errorMessage` envelope returned by ProjectsResponseType.
export default async function lpApi(query, variables = {}) {
  const res = await fetch('/lp-graphql', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
    credentials: 'same-origin',
  });
  return res.json();
}
